import React, { Component } from "react";
import Title from "../../SubscriptionsInfo/Title/Title";
import List from "../../SubscriptionsInfo/List/SubscriptionList";
import SearchBar from "../../SubscriptionsInfo/SearchBar/SearchBar";
import SpreadTable from "./Table/Index";
import Page from "../../framework/Page/Page";
import moment from "moment/moment";
import { downLoadCSVFunc } from "../../../utils/utility";
import isEmpty from "lodash/isEmpty";

class ClientBusinessInfo extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.state = {
      requestParams: {
        clientId: "",
        pageNumber: 1,
        pageSize: 15,
        sortColumn: "clientName",
        order: "asc",
      },
    };
  }
  componentDidMount() {
    this.props.getClientBusinessTotal();
    this.props.clientBusinessSearch(this.state.requestParams);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.search_results.clients && this.throttle) {
      this.setState(
        {
          requestParams: {
            ...this.state.requestParams,
            pageSize: nextProps.search_results.clients.total,
          },
        },
        () => {
          this.props.getAllSearch(this.state.requestParams);
        },
      );
      this.throttle = false;
    }
  }
  handleSearch(selectedItem) {
    let obj = {};
    if (selectedItem === "") {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: "",
          pageNumber: 1,
          pageSize: 15,
        },
      };
      this.goToPage(1);
    } else {
      obj = {
        requestParams: {
          ...this.state.requestParams,
          clientId: selectedItem,
          pageNumber: 1,
          pageSize: 15,
        },
      };
    }
    this.setState(obj, () => {
      this.props.clientBusinessSearch(this.state.requestParams);
    });
  }
  nextBeClick(page) {
    this.pageAbleFunc(page);
  }
  previousBeClick(page) {
    this.pageAbleFunc(page);
  }
  goToPage(page) {
    this.pageAbleFunc(page);
  }
  pageAbleFunc(val) {
    this.setState(
      {
        requestParams: {
          ...this.state.requestParams,
          pageNumber: val,
          pageSize: 15,
        },
      },
      () => {
        this.props.clientBusinessSearch(this.state.requestParams);
      },
    );
  }
  handleSortByClientName() {
    this.setState(
      {
        requestParams: {
          ...this.state.requestParams,
          pageSize: 15,
          order: this.state.requestParams.order === "desc" ? "asc" : "desc",
        },
      },
      () => {
        this.props.clientBusinessSearch(this.state.requestParams);
      },
    );
  }
  handleDownload() {
    let title = "AudienceAnywhere Clients and Business Units,,,,,\r\n";
    let clients = `Clients,${
      this.props.client_business_total[0].value
    },,,,\r\n`;
    let join = `Joined last 30 days,${
      this.props.client_business_total[1].value
    },,,,\r\n`;
    let business = `Business Units,${
      this.props.client_business_total[2].value
    },,,,\r\n`;
    let bsjoin = `Joined last 30 days,${
      this.props.client_business_total[3].value
    },,,,\r\n`;
    let data = "";
    const childrenLoop = item => {
      data += `"${item.clientName}",${item.bizUnitName || ""},"${item.industry
        .name || ""}","",${moment(item.createdTime).format("M/DD/YY") ||
        ""},${item.status || ""}\r\n`;
    };
    for (const v of this.props.all_search_results.clients.data) {
      if (v.children) {
        data += `"${v.clientName}",${v.bizUnitName || ""},"${v.industry.name ||
          ""}","${v.accountManagers[0] ? v.accountManagers[0].firstName : ""} ${
          v.accountManagers[0] ? v.accountManagers[0].lastName : ""
        }",${moment(v.createdTime).format("M/DD/YY") || ""},${v.status ||
          ""}\r\n`;
        v.children.forEach(childrenLoop);
      } else {
        data += `"${v.clientName}",${v.bizUnitName || ""},"${v.industry.name ||
          ""}","${v.accountManagers[0] ? v.accountManagers[0].firstName : ""} ${
          v.accountManagers[0] ? v.accountManagers[0].lastName : ""
        }",${moment(v.createdTime).format("M/DD/YY") || ""},${v.status ||
          ""}\r\n`;
      }
    }
    let csv_string =
      title +
      clients +
      join +
      business +
      bsjoin +
      ",,,,,\r\n" +
      "Client Name,Business Unit Name,Industry,Account Manager,Profile Creation Date,Status\r\n" +
      data;
    downLoadCSVFunc(
      csv_string.trim(),
      "AA_Client_Business_" + moment().format("YYYYMMDD"),
    );
  }
  render() {
    const clientsBizListData = [];
    const { client_business_total } = this.props;
    if (!isEmpty(client_business_total)) {
      clientsBizListData.push(
        client_business_total.find(data => {
          return data.item === "totalClients";
        }),
      );
      clientsBizListData.push(
        client_business_total.find(data => {
          return data.item === "totalBizUnit";
        }),
      );
      clientsBizListData.push(
        client_business_total.find(data => {
          return data.item === "clientsJoinLastMonth";
        }),
      );
      clientsBizListData.push(
        client_business_total.find(data => {
          return data.item === "bizUnitJoinLastMonth";
        }),
      );
    }

    return (
      <div className="subscription-info">
        <div className="title-wrapper">
          <Title
            crumb="Client/Business Unit"
            handleDownload={() => this.handleDownload()}
          />
        </div>
        <div className="sub-info-container">
          <div className="common-wrapper">
            <h2>TOTAL NUMBER OF CLIENT/BUSINESS UNITS</h2>
            <div className="list">
              <List hiddenMiddleBorder={true} data={clientsBizListData} />
            </div>
          </div>
          <div className="common-wrapper mt-20">
            <h2 className="border-title">CLIENT/BUSINESS UNIT</h2>
            <div className="search-bar">
              <SearchBar
                clients={this.props.clients}
                handleSearch={selectedItem => this.handleSearch(selectedItem)}
              />
              <div className="spread-table-wrapper">
                <SpreadTable
                  handleSortByClientName={() => this.handleSortByClientName()}
                  tableHeaderArr={[
                    { label: "Client Name", value: 0 },
                    { label: "Business Unit Name", value: 1 },
                    { label: "Industry", value: 2 },
                    // {label: 'Account Manager', value: 3},
                    { label: "Profile Creation Date", value: 4 },
                    { label: "Status", value: 5 },
                    // {label: 'Tag Creation Date', value: 6}
                  ]}
                  tableHeaderWidthStyle={["25%", "23%", "25%", "14%", "8%"]}
                  bodyDataArr={
                    this.props.search_results.clients
                      ? this.props.search_results.clients.data
                      : []
                  }
                  renderCols={{
                    addCol: "",
                    cols: [
                      "clientName",
                      "bizUnitName",
                      "industry",
                      "createdTime",
                      "status",
                    ],
                  }}
                />
                <Page
                  nextBeClick={page => this.nextBeClick(page)}
                  pageNumber={
                    this.props.search_results.clients &&
                    this.props.search_results.clients.pageNumber
                  }
                  pageCount={
                    this.props.search_results.clients &&
                    this.props.search_results.clients.pageCount
                  }
                  pageSize={
                    this.props.search_results.clients &&
                    this.props.search_results.clients.pageSize
                  }
                  nextGroupBeClick={page => this.nextGroupBeClick(page)}
                  previousGroupBeClick={page => this.previousGroupBeClick(page)}
                  previousBeClick={page => this.previousBeClick(page)}
                  pageBeClick={page => this.pageBeClick(page)}
                  total={
                    this.props.search_results.clients &&
                    this.props.search_results.clients.total
                  }
                  hasNext={
                    this.props.search_results.clients &&
                    this.props.search_results.clients.hasNext
                  }
                  hasPrevious={
                    this.props.search_results.clients &&
                    this.props.search_results.clients.hasPrevious
                  }
                  pagePlus={true}
                  selectRows={(page, row) => this.selectRows(page, row)}
                  goToPage={page => this.goToPage(page)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClientBusinessInfo;



// WEBPACK FOOTER //
// ./src/components/ClientBusinessInfoAndUser/ClientBusiness/Index.jsx